import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useI18n } from '../../i18n'
import StructuredDataView from '../../components/StructuredDataView'
import { formatLocalDate, statusTone } from './helpers'

export function StatusBadge({ status }) {
  const { t } = useI18n()
  const key = `autotests.status.${status}`
  const label = key === t(key) ? String(status || 'UNKNOWN') : t(key)
  return (
    <span className={`autotests-status autotests-status--${statusTone(status)}`}>
      {label}
    </span>
  )
}

export function ExpandableText({ text, className = '' }) {
  const { t } = useI18n()
  const [expanded, setExpanded] = React.useState(false)
  const [canExpand, setCanExpand] = React.useState(false)
  const textRef = React.useRef(null)
  const safe = text == null || text === '' ? '—' : String(text)

  React.useEffect(() => {
    if (expanded) {
      setCanExpand(true)
      return
    }
    if (safe === '—') {
      setCanExpand(false)
      return
    }
    const el = textRef.current
    if (!el) {
      setCanExpand(false)
      return
    }
    setCanExpand(el.scrollHeight > el.clientHeight + 1)
  }, [expanded, safe])

  return (
    <div className={`autotests-expandable ${expanded ? 'is-expanded' : ''} ${className}`.trim()}>
      <p ref={textRef} className="autotests-expandable-text">{safe}</p>
      {safe !== '—' && canExpand && (
        <button type="button" className="autotests-link-btn" onClick={(e) => { e.stopPropagation(); setExpanded((v) => !v) }}>
          {expanded ? t('autotests.collapse') : t('autotests.expand')}
        </button>
      )}
    </div>
  )
}

export function JsonViewer({ value }) {
  return <StructuredDataView value={value} compact className="autotests-data-view" />
}

export function AccessDeniedView({ message }) {
  const { t } = useI18n()
  const navigate = useNavigate()

  return (
    <div className="autotests-access">
      <h2>{t('autotests.noAccess.title')}</h2>
      <p>{message || t('autotests.noAccess.message')}</p>
      <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)}>
        {t('autotests.noAccess.back')}
      </button>
    </div>
  )
}

export function MetaRow({ label, value }) {
  return (
    <div className="autotests-meta-row">
      <span className="autotests-meta-key">{label}</span>
      <span className="autotests-meta-value">{value ?? '—'}</span>
    </div>
  )
}

export function DateCell({ iso }) {
  return <span>{formatLocalDate(iso)}</span>
}
